import React from 'react'
import "../../Assets/Css/AttendanceByLocation.scss"

function AttendanceByLocation() {
  return (
    <div className="attendance-table mb-5 mt-4">
      <h5>AttendanceByLocation</h5>

      <div className='map-iframe-div'>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3670.251761720375!2d72.52649997477216!3d23.08787791388898!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e83f3cce667eb%3A0xf97d507284275470!2sAgarwal%20Mall!5e0!3m2!1sen!2sin!4v1726901625182!5m2!1sen!2sin"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        >
        </iframe>
      </div>
    </div>
  )
}

export default AttendanceByLocation